let { html, nothing, render, guard, unsafeSVG, repeat, keyed, CustomTokenHTMLElement, on, translation, utils } = lithtml;
const tag     = 'wave-memo-tasks';
const version = '0.9.21';

// Hash of properties that will trigger getting tasks from the Tasks Api
let propsTriggeringGettingTasks = { _aZ: 1, userData: 1, memoType: 1, memoId: 1, tasksUrl: 1 };

// Available modules, that is used as memo types
let _a0 = {
    Connection: { type: 'WaterConnectionMemo'            , domain: 5, value: 'Connection' },
    Customer  : { type: 'PrivateFacilitiesCustomerMemo'  , domain: 0, value: 'Customer'   }, // Customer is for all basis? Building, customer, property, ...?
    Backflow  : { type: 'PrivateFacilitiesBackflowMemo'  , domain: 1, value: 'Backflow'   },
    Industry  : { type: 'PrivateFacilitiesIndustryMemo'  , domain: 3, value: 'Industry'   },
    Watermeter: { type: 'PrivateFacilitiesWaterMeterMemo', domain: 2, value: 'Watermeter' },
    Matrikkel : { type: 'PrivateFacilitiesMatrikkelMemo' , domain: 0, value: 'Matrikkel'  }, // Which domain? Vei og grunn???
    Sludge    : { type: 'PrivateFacilitiesSludgeMemo'    , domain: 4, value: 'Sludge'     },
    Discharge : { type: 'PrivateFacilitiesDischargeMemo' , domain: 4, value: 'Discharge'  },
  //Excavation: { type: 'ExcavationMemo'                 , domain: 6, value: 'Excavation' }
};

// /** @type {string} the base url of where the script was downloaded from */
//let scriptBase = document.currentScript.src;
//scriptBase = scriptBase && scriptBase.substring(0, scriptBase.lastIndexOf('/'));
//console.log(scriptBase);

let { getIsoDateStr } = utils;
let dateFormat = Intl.DateTimeFormat('no', {day: '2-digit', month:'2-digit', year:'numeric'});

// English and norwegian translations, english is default language
let t = translation.init(tag, version);
t.add(['en', 'no'], {
    Tasks                          : [ 'Tasks'               , 'Oppgaver'               ],
    WaterConnectionMemo            : [ 'Connections'         , 'Tilkoblinger'           ],
    PrivateFacilitiesCustomerMemo  : [ 'Customer'            , 'Kunde'                  ],
    PrivateFacilitiesBackflowMemo  : [ 'Backflow'            , 'Tilbakestrømning'       ],
    PrivateFacilitiesIndustryMemo  : [ 'Industry'            , 'Industripåslipp'        ],
    PrivateFacilitiesWaterMeterMemo: [ 'Watermeter'          , 'Vannmåler'              ],
    PrivateFacilitiesMatrikkelMemo : [ 'Matrikkel'           , 'Matrikkel'              ],
    PrivateFacilitiesSludgeMemo    : [ 'Sludge'              , 'Slam'                   ],
    PrivateFacilitiesDischargeMemo : [ 'Discharge'           , 'Utslipp'                ],
    ExcavationMemo                 : [ 'Excavation'          , 'Vei og grunn'           ],
    Private                        : [ 'Private'             , 'Privat'                 ],
    Public                         : [ 'Public'              , 'Offentlig'              ],
    AddMemo                        : [ 'Add memo'            , 'Legg til huskelapp'     ],
    EditMemo                       : [ 'Edit memo'           , 'Rediger huskelapp'      ],
    Save                           : [ 'Save'                , 'Lagre'                  ],
    Cancel                         : [ 'Cancel'              , 'Avbryt'                 ],
    Edit                           : [ 'Edit'                , 'Rediger'                ],
    Delete                         : [ 'Delete'              , 'Slett'                  ],
    CompleteTask                   : [ 'Complete task'       , 'Fullfør oppgaven'       ],
    YesDelete                      : [ 'Yes, delete'         , 'Ja, slett'              ],
    YesComplete                    : [ 'Yes, complete'       , 'Ja, fullfør'            ],
    PrivateTask                    : [ 'Private task'        , 'Privat oppgave'         ],
    Yes                            : [ 'Yes'                 , 'Ja'                     ],
    No                             : [ 'No'                  , 'Nei'                    ],
    Module                         : [ 'Module'              , 'Fagområde'              ],
    ModuleType                     : [ 'Logtype'             , 'Merknadstype'           ],
    DueDate                        : [ 'Duedate'             , 'Utføres innen'          ],
    Title                          : [ 'Title'               , 'Tittel'                 ],
    Description                    : [ 'Description'         , 'Beskrivelse'            ],
    DeleteMemo                     : [ 'Delete memo?'        , 'Slette huskelapp?'      ],
    CompleteMemo                   : [ 'Complete memo?'      , 'Fullfør huskelapp?'     ],
    UpdateMemo                     : [ 'Updating memo'       , 'Oppdaterer huskelapp'   ],
    AddMemo                        : [ 'Adding memo'         , 'Legger til huskelapp'   ],
    TitleIsMandatory               : [ 'Title is mandatory'  , 'Tittel er obligatorisk' ],
    MandatoryField                 : [ 'Duedate is mandatory', 'Feltet er obligatorisk' ],
    DeleteMemoAreYouSure           : [ 'Are you sure you want to delete this memo?'  , 'Er du sikker på at du ønsker å slette denne huskelappen?'  ],
    CompleteMemoAreYouSure         : [ 'Are you sure you want to complete this memo?', 'Er du sikker på at du ønsker å fullføre denne huskelappen?'],
});

t.load(translation.language);

//on('language-changed', e => {
//    t.load(e.lang);
//});

let _a1, _a2, DatePicker;

/**
 * Memo tasks element that displays memo tasks based on filters
 */
class WaveMemoTasksElement extends CustomTokenHTMLElement {
    static get tag()     { return tag }
    static get version() { return version }

    //
    static get observedAttributes() { return ['memo-type', 'memo-id', 'allow-no-memo-id', 'memo-module', 'disable-module-selection', 'memo-data', 'tasks-url']; }
    static get observedProperties() { return ['_a3', '_aZ' ]; }

    /**
     * Constructor
     */
    constructor() {
        super(WaveMemoTasksElement);
    }

// * Test
// ! Test
// ? Test

    /**
     * Called when the custom element is connected to the DOM the first time
     */
    onFirstConnected() {
        super.onFirstConnected();

        let self = this;
        let css  = self._a4().strings[0].replace('<style>', '').replace('</style>', '');

        self.$setShadowStyle(css);

        // Override current language?
        if (self.$attribs.language) {
            t.load(self.$attribs.language);
        }
    }

    /** */
    onDisconnected() {
        // TODO: destroy?
        let dialogEl = document.getElementById('memo_dialog_wrapper');

        if (dialogEl) {
            dialogEl.remove();
        }
    }

    /**
     * Called when an observed property (or attribute) changes value
     * @param {string} name the name of the property
     * @param {string} oldValue the old value of the property
     * @param {string} newValue the new value of the property
     */
    onPropertyChanged(name, oldValue, newValue) {
        let self = this;

        //console.log('Prop changed', name + ':', newValue);

        if (name in propsTriggeringGettingTasks) {
            // Do not trigger getting tasks each time the token is updated
            if (name === 'userData' && oldValue) {
                return;
            }

            self._a5();
        }

        if (name === 'tasksUrl' && newValue) {
            self._aZ = newValue;
        }

        if (name === 'memoModule') {
            // Make sure we always have a valid memo module selected
            if (newValue && !_a0[newValue]) {
                self.memoModule = Object.values(_a0).sort((a, b) => t(a.type) > t(b.type) ? 1 : -1)[0].value;
                self._a6 = true;
            }
        }
    }

    /**
     * Called when the component needs to render
     */
    render(reason) {
        let self = this;

        return html`<div class="header"><h3>${t('Tasks')}</h3>${self._a7
                    ? nothing
                    : self._a3
                        ? html`<div class="circle counter">${self._a3.length}</div><div class="circle" @click="${self._a8}"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5m-7 7h14"/></svg></div>`
                        : html`<div class="loader"></div>`
                }</div><div style="overflow-y:auto" @click="${self._a9}">${self._a7 ? html`<div style="color:red;word-break:break-word">${self._a7}</div>` : nothing } ${self._a3 && repeat(self._a3, (task) => task.Id, (task) => html`<div class="taskItem" .taskId="${task.Id}" .id="${task.Id}"><div class="taskicon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m2 0H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M8 5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9m7 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6"/></svg></div><div><div class="delta">${task.Title}</div><div class="zeta gray100">${dateFormat.format(new Date(task.DueDate))}</div></div></div>`)}</div>`;
    }

    /**
     * Updates the token and user data
     * @param {*} tokenAndUserInfo
     */
    onUserData(userData) {
        let self = this;

        if (!self._aZ) {
            let token = JSON.parse(window.atob(userData.accessToken.split('.')[1]));

            self._aZ = self._ba(token.iss);
            self._bb    = self._bc(token.iss);
        }
    }

    /**
     * Show the dialog to add a new memo task
     * @param {MouseEvent} e the click event
     */
    _a8(e) {
        let self = this;

        self._bd      = true;
        self._be     = false;
        self._bf   = false;
        self._bg = false;

        self._bh();
    }

    /**
     * Show the dialog displaying memo task details
     * @param {MouseEvent} e the click event
     */
    _a9(e) {
        let self   = this;
        let taskEl = e.composedPath().filter(i => !!i.taskId)[0];
        let taskId = taskEl?.taskId;
        let task   = taskId && self._a3.filter(t => t.Id === taskId)[0];

        self._bd      = false;
        self._be     = false;
        self._bf   = false;
        self._bg = false;

        //console.log(taskId, task);

        task && self._bh(task);
    }

    /**
     * Closes the dialog
     */
    _bi() {
        let self     = this;
        let dialogEl = document.getElementById('memo_dialog_wrapper');

        dialogEl?.remove();

        if (self._bj) {
            self._bj.off('change');
            self._bj = null;
        }

        self._bk = null;
    }

    /**
     * Show the memo task dialog
     * @param {*} [task] the task (empty if new)
     */
    _bh(task) {
        let self = this;

        // Try to support datetimepicker if VolueUI/PowelUI is used/available
        DatePicker = DatePicker || self.DatePicker || (window.VolueUI || window.PowelUI || self.VolueUI || self.PowelUI)?.DatePicker;

        // Make sure we have the memo subtypes
        if(!(_a1 || _a2)) {
            _a1 = fetch(self._bb + '/api/v3/eventlogsubtype', {
                headers: {
                    Authorization: 'Bearer ' + self.userData.accessToken
                }
            })
                .then(response => {
                    if (response.ok) {
                        _a1 = null;
                        return response.json();
                    }
                })
                .then(data => {
                    _a2 = data;

                    self._bl(task.Type);
                });
        }

        // Initalize the task (new or edit)
        task = Object.assign(Object.create(null), task || {});

        self._bm = {
            dueDate: false,
            title: false,
            type: false
        }

        self._bn = false;

        // If new task, make sure we have default values
        if (!task.Title) {
            task.Description = '';
            task.Title       = '';

            let module = _a0[self.memoModule];

            task.Type = module ? module.type : null;
        }

        let dialog = () => html`<div id="memo_dialog_wrapper" style="position:absolute;top:0;bottom:0;left:0;right:0;background:rgba(127,127,127,.35);display:flex;align-items:center;opacity:.25;justify-content:center;z-index:100;transition:opacity .2s">${self._bo()}<div id="memo_dialog" class="boxShadow-lift mAs dF fdC ofH" style="background:#fff;border-radius:6px;min-width:380px;max-width:600px;width:100%;transform:translateY(15%);transition:transform .25s;max-height:95%">${self._bp
                        ? html`<div style="position:absolute;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:rgba(127,127,127,.55);z-index:10;border-radius:6px"><div class="pAl boxShadow-lift" style="background:#fff;border-radius:3px;display:flex;align-items:center"><div class="wmtLoader"></div>${self._bq}....</div></div>`
                        : nothing
                    }<div class="pAm XXmAm dF fdC ofH"><div class="dF fdR aiC" style="display:flex;border-bottom:1px solid #ebebe9"><div class="fg1 pAs pRl gamma gray130">${self._br(task)}</div><div class="pHs dF aiC" style="cursor:pointer" @click="${self._bi}"><svg style="width:24px;height:24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18 18 6M6 6l12 12"/></svg></div></div>${self._be || self._bd
                            ? self._bs(task)
                            : self._bf
                                ? self._bt(task)
                                : self._bg
                                    ? self._bu(task)
                                    : self._bv(task)
                        }<div class="pHs pTm dF aiC" style="border-top:1px solid #ebebe9">${self._bw(task)}</div></div></div></div>`;

        // Use keyed to force a rerender of the dialog always
        let keyedId = Date.now();
        self._bk = () => render(keyed(keyedId, dialog()), document.body, { host: self });
        self._bk();

        if (_a2) {
            self._bl(task?.Type);
        }

        // Fade in the dialog
        setTimeout(() => {
            document.getElementById('memo_dialog_wrapper').style.opacity = 1;
            document.getElementById('memo_dialog').style.transform = 'translateY(0)';
        }, 0)
    }

    /**
     * Gets the dialog style
     * @returns {import("lit-html").TemplateResult}
     */
    _bo() {
        return html`<style>.wmtError input{border:1px solid red}.wmtLoader,.wmtLoader:after{border-radius:50%;width:16px;height:16px}.wmtLoader{border:3px solid rgba(0,83,128,.3);border-left:3px solid #005380;transform:translateZ(0);animation:wmtSpinner 1.1s infinite linear;display:inline-block;margin-right:6px}@keyframes wmtSpinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style>`
    }

    /**
     * Get the details view of a memo task
     */
    _bv(task) {
        let self = this;

        return html`<div class="pAm"><div class="pBm"><div class="fwB">${t(task.Type)} ${_a2 && task.SubType ? html`<div class="dIB epsilon gray100">(${_a2.filter(t => t.code === task.SubType)[0]?.title || task.SubType})</div>` : nothing}</div><div class="zeta gray100">${dateFormat.format(new Date(task.DueDate))}</div></div><div><div class="dIB pRs"><svg style="width:16px;height:16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${task.OwnerUserId ? unsafeSVG('<path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2m-8-10a4 4 0 1 0-4-4m4 4a4 4 0 1 1 4-4"/>') : unsafeSVG('<path d="M1 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2M9 11a4 4 0 1 0-4-4m4 4a4 4 0 1 1 4-4m7 8.13A4 4 0 0 1 23 19v2m-7-10.12a4 4 0 0 0 0-7.75"/>')}</svg></div><span>${task.OwnerUserId ? t('Private') : t('Public')}</span></div><div class="pVm pBn gray100">${task.Description}</div></div>`;
    }

    /**
     * Get the header text, which difffers on new, edit and detailview
     * @param {*} task
     * @returns {string} the header
     */
    _br(task) {
        let self = this;

        return self._bd
            ? t('AddMemo')
            : self._be
                ? t('EditMemo')
                : task.Title
    }

    /**
     * Get the buttons view, which depends on the mode we're in (edit, new, delete, complete)
     * @param {*} task
     * @returns {import("../types/lit-html").TemplateResult} the buttons template
     */
    _bw(task) {
        let self = this;

        return self._be
                ? html`${self._bx ? html`<div style="color:red;word-break:break-word">${self._bx}</div>`: nothing} <button class="pAs mLa pRl" @click="${() => { self._be=false; self._bk(); }}"><strong class="navy100">${t('Cancel')}</strong></button> <button class="btn fill-blue125 mRs" @click="${() => { self._by(task) && self._bz(task); }}">${t('Save')}</button>`
                : self._bf
                    ? html`<button class="pAs mLa pRl" @click="${() => { self._bf=false; self._bk(); }}"><strong class="navy100">${t('Cancel')}</strong></button> <button class="btn fill-red100 mRs" @click="${() => { self._bA(task.Id, 'delete'); }}">${t('YesDelete')}</button>`
                    : self._bg
                        ? html`<button class="pAs mLa pRl" @click="${() => { self._bg=false; self._bk(); }}"><strong class="navy100">${t('Cancel')}</strong></button> <button class="btn fill-green100 mRs" @click="${() => { self._bA(task.Id, 'complete'); }}">${t('YesComplete')}</button>`
                        : self._bd
                            ? html`${self._bx ? html`<div style="color:red;word-break:break-word">${self._bx}</div>`: nothing} <button class="btn fill-blue125 mLa mRs" @click="${() => { self._by(task) && self._bz(task); }}">${t('Save')}</button>`
                            : html`<button class="pAs" @click="${() => { self._be=true;     self._bk(); }}"><strong class="navy100">${t('Edit')}</strong></button> <button class="pAs" @click="${() => { self._bf=true;   self._bk(); }}"><strong class="gray100">${t('Delete')}</strong></button> <button class="btn fill-blue125 mLa mRs" @click="${() => { self._bg=true; self._bk(); }}">${t('CompleteTask')}</button>`
    }

    /**
     * Validate new/edited task data
     * @param {*} task
     * @returns
     */
    _by(task) {
        let self      = this;
        let valErrors = self._bm;
        let failed    = self._bn;

        valErrors.dueDate = !task.DueDate;
        valErrors.title   = !task.Title;
        valErrors.type    = !task.Type;
// TODO: Validate dueDate is in the future if changed
//       valErrors.dueDateInPast = true/false
        self._bn = (valErrors.dueDate || valErrors.title || valErrors.type);

        if (failed || self._bn) {
            self._bk();
        }

        return !self._bn;
    }

    /**
     * Get view of add/edit a memo task
     * @param {*} task
     * @returns
     */
    _bs(task) {
        let self = this;

        return html`<div class="pAm" style="overflow-y:auto"><div class="toggleSwitch toggleSwitch--is-enabled ${task.OwnerUserId ? 'toggleSwitch--is-checked' : nothing}"><label class="toggleSwitch-label" for="privatetask">${t('PrivateTask')}</label><div class="toggleSwitch-slider"><button class="toggleSwitch-button" role="checkbox" type="button" id="privatetask" @click="${(e) => {task.OwnerUserId = task.OwnerUserId ? null : self.userData.userInfo.name; self._bk();}}"></button><div class="toggleSwitch-track"></div><div class="toggleSwitch-stateText toggleSwitch-stateText--on">${t('Yes')}</div><div class="toggleSwitch-stateText toggleSwitch-stateText--off">${t('No')}</div></div></div><div class="dF pTm" style="flex-wrap:wrap"><div class="fg3 fb0 pRs ${self._bn && self._bm.title ? 'wmtError' : ''}"><label>${t('Title')}*</label> <input id="memoTitle" type="text" .value="${task.Title}" @input="${(e) => { task.Title = e.target.value; self._bn && self._by(task); }}" required> ${self._bn && self._bm.title ? html`<div style="color:red;word-break:break-word">${t('TitleIsMandatory')}</div>` : nothing}</div><div class="fg2 fb0 ${self._bn && self._bm.dueDate ? 'wmtError' : ''}"><label>${t('DueDate')}*</label> ${
                            DatePicker
                                ? guard([task], () => {
                                    queueMicrotask(() => {
                                        let dateEl = document.getElementById('memoDueDate');

                                        self._bj = DatePicker(dateEl, { format: 'dd.mm.yyyy', firstDay: 1, triggerChangeOnEmpty: true})

                                        self._bj.on('change', (date) => {
                                            task.DueDate = self._bj.value();
                                            self._bn && self._by(task);
                                        })

                                        // Hack to prevent bug in PowelUI DatePicker (missing .cal.min function).
                                        if (self._bj._native) {
                                            dateEl.min = getIsoDateStr (new Date());
                                        }
                                        else {
                                            self._bj.min(new Date());
                                        }

                                        self._bj.value(task.DueDate);
                                    })
                                    return html`<div><span class="formIcon w100 ${self._bn && self._bm.dueDate ? 'wmtError' : ''}"><i class="pf pf-calendar" aria-hidden="true" style="left:auto;right:.5em;pointer-events:none"></i> <input id="memoDueDate" autocomplete="off" style="padding-left:.5em;cursor:pointer" placeholder="dd.mm.yyyy" type="text" required pattern="^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$"></span></div>`})
                                : html`<input id="memoDueDate" class="${self._bn && self._bm.dueDate ? 'wmtError' : ''}" type="date" min="${getIsoDateStr (new Date())}" .value="${task.DueDate ? getIsoDateStr (new Date(task.DueDate)) : ''}" @change="${(e) => { task.DueDate = e.target.value; self._bn && self._by(task); }}" required>`
                        } ${self._bn && self._bm.dueDate ? html`<div style="color:red;word-break:break-word">${t('MandatoryField')}</div>` : nothing}</div></div><div class="dF pTm" style="flex-wrap:wrap"><div class="fg3 fb0 pRs"><label>${t('Module')}*</label> <select class="${self._bn && self._bm.type ? 'wmtError' : ''}" id="memoType" ?disabled="${self._be || (!self._a6 && self.disableModuleSelection)}" .value="${task.Type}" @change="${(e) => { task.Type = e.target.value; self._bl(task.Type); }}">${ guard([task], () => repeat(Object.values(_a0).sort((a, b) => t(a.type) > t(b.type) ? 1 : -1), item => item.type, item => html`<option value="${item.type}" ?selected="${item.type === task.Type}">${t(item.type)}</option>`))}</select></div><div class="fg2 fb0"><label>${t('ModuleType')} ${_a2 ? nothing : html`<div class="wmtLoader"></div>`}</label> <select ?disabled="${!_a2}" .value="${task.SubType}" @change="${(e) => task.SubType = e.target.value}"><option value=""></option>${self._bB
                                ? repeat(self._bB, item => item.code, item => html`<option value="${item.code}" ?selected="${item.code === task.SubType}">${item.title}</option>`)
                                : nothing }</select></div></div><div class="pBm"></div><div><label>${t('Description')}</label> <textarea class="pVm pBn gray100" rows="4" .value="${task.Description}" @change="${(e) => task.Description = e.target.value}"></textarea></div></div>`;
    }

    /**
     * Get the 'Are you sure...?' template for deleting a memo task
     * @param {*} task
     * @returns {import("../types/lit-html").TemplateResult} the delete-memo-task template
     */
    _bt(task) {
        return html`<div class="pAm txtC pVl"><div class="pBm pTm"><strong>${t('DeleteMemo')}</strong></div><div class="pBm">${t('DeleteMemoAreYouSure')}</div></div>`;
    }

    /**
     * Get the 'Are you sure...?' template for completing a memo task
     *
     * @param {*} task
     * @returns {import("../types/lit-html").TemplateResult} the complete-memo-task template
     */
    _bu(task) {
        return html`<div class="pAm txtC pVl"><div class="pBm pTm"><strong>${t('CompleteMemo')}</strong></div><div class="pBm">${t('CompleteMemoAreYouSure')}</div></div>`;
    }

    /**
     *
     * @param {string} taskType the task type (module)
     */
    _bl(taskType) {
        if(!taskType) {
            return;
        }

        let self  = this;
        let index = Object.values(_a0).filter(m => m.type === taskType)[0].domain;

        self._bB = _a2.filter(item => item.isActive && (item.domain === index || item.domain === null)).sort((a, b) => a.title < b.title ? -1 : 1);
        self._bk();
    }

    /**
     * Retrieves tasks based on memo filters
     */
    _a5() {
        let self = this;

        if (!((self._aZ && self.userData) && self.memoType)) {
            return;
        }

        if (!(self.memoId || self.allowNoMemoId)) {
            return;
        }

        if (self._bC) {
            return;
        }

        self._bC = true;
        self._a3 = null;

        let tagFilter = 'extobj' +  (self.memoId ? 'id' : '') + ':' + self.memoType + (self.memoId ? ':' + self.memoId : '');

        fetch(self._aZ + '/api/memos?filter=' + tagFilter, {
            headers: {
                Authorization: 'Bearer ' + self.userData.accessToken
            }
        })
            .then(response => {
                if (response.status > 299 || response.status < 200) {
                    throw {
                        message: response.statusText ? response.statusText + ' (' + response.status + ')' : response.status + ' (unknown error)'
                    }
                }

                return response.json()
            })
            .then(tasks => {
                self._a7 = null;
                self._a3 = tasks;

                tasks.forEach(task => task.SubType = (task.Tags.filter(tag => tag.startsWith('eventLogSubtype:'))[0] || '').substring(16) || null);
            })
            .catch(error => {
                self._a7 = error.message || 'Uknown error occured getting memos';
                self.requestRender('error');
            })
            .finally(_ => {
                self._bC = false;
            });
    }

    /**
     * Delete or complete a memo
     * @param {string} taskId the id of the memo to be completed/deleted
     * @param {'complete'|'delete'} cmd the command to execute, 'complete' or 'delete'
     */
    _bA(taskId, cmd) {
        let self = this;

        self._bp  = true;
        self._bq = cmd === 'delete' ? 'Sletter huskelapp' : 'Fullfører huskelapp';

        self._bk();

        self.$triggerEvent(`wave-memo-${(cmd === 'delete' ? 'delete' : 'complete')}`, {
            data: self._a3.filter(t => t.Id === taskId)[0]
        });

        fetch(`${self._aZ}/api/memos/${taskId}${(cmd === 'complete' ? '/setdone' : '')}`, {
            method: cmd === 'delete' ? 'DELETE' : 'PUT',
            headers: {
                Authorization: 'Bearer ' + self.userData.accessToken
            }
        })
            .then(response => {
                if (response.status > 299 || response.status < 200) {
                    throw {
                        message: response.statusText ? `${response.statusText} (${response.status})` : response.status + ' (unknown error)',
                        response
                    }
                }

                self._a7 = null;

                let indexOfTask = self._a3.findIndex(t => t.Id === taskId);

                self._a3.splice(indexOfTask, 1);
                self.requestRender('taskcomplete');
                self._bi();
            })
            .catch(error => {
                let response = error.response;

                if (response) {
                    response.text().then(msg => {
                        self._a7 = msg || `${(response.statusText ? response.statusText : 'Unknown error')} (${response.status})`;
                        self.requestRender('error');
                    });
                }
                else {
                    self._a7 = error.message || 'Uknown error';
                    self.requestRender('error');
                }
            })
            .finally(_ => {
                self._bp = false;
            });
    }

    /**
     *
     * @param {*} task
     */
    _bz(task) {
        let self = this;

        self._bx  = null;
        self._bp  = true;
        self._bq = task.Id ? t('UpdateMemo') : t('AddMemo');
        task.Tags       = task.Tags || [];

        if (task.Tags.indexOf('extobj:' + self.memoType) === -1) {
            task.Tags.push('extobj:' + self.memoType);

            if (self.memoId) {
                task.Tags.push(`extobjid:${self.memoType}:${self.memoId}`);
            }

            task.Url = location.href;
        }

        // Make sure subtype is updated
        task.Tags = task.Tags.filter(t => t.indexOf('eventLogSubtype:') === -1);
        task.SubType && task.Tags.push('eventLogSubtype:' + task.SubType);

        self._bk();

        self.$triggerEvent(`wave-memo-${(task.Id ? 'update' : 'add')}`, {
            data: task
        });

        if (!task.Id) {
            task.Data = self.memoData || [];
        }

        fetch(`${self._aZ}/api/memos${(task.Id ? '/' + task.Id : '')}`, {
            method: task.Id ? 'PUT' : 'POST',
            headers: {
                Authorization: 'Bearer ' + self.userData.accessToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(task)
        })
            .then(response => {
                if (response.status > 299 || response.status < 200) {
                    throw {
                        message: response.statusText ? `${response.statusText} (${response.status})` : response.status + ' (unknown error)',
                        response
                    }
                }

                return response.json();
            })
            .then(updTask =>  {
                self._bx = null;

                let indexOfTask = self._a3.findIndex(t => t.Id === updTask.Id);

                updTask.SubType = task.SubType;

                if (indexOfTask !== -1){
                    self._a3.splice(indexOfTask, 1, updTask);
                }
                else {
                    self._a3.push(updTask);
                }

                self.requestRender('taskcomplete');
                self._bk();
                self._bi();
            })
            .catch(error => {
                let response = error.response;

                if (response) {
                    response.json().then(msg => {
                        self._bx = msg || `${(response.statusText ? response.statusText : 'Unknown error')} (${response.status})`;
                        self._bk();
                        self.requestRender('error');
                    });
                }
                else {
                    self._bx = error.message || 'Uknown error';
                    self._bk();
                    self.requestRender('error');
                }
            })
            .finally(_ => {
                self._bp = false;
                self.requestRender('addupdatedone');
            });
    }

    /**
     * Get the style of the element
     * @returns {import("lit-html").TemplateResult} the style TemplateResult
     */
    _a4 (a) {
        // INFO: spinner from https://projects.lukehaas.me/css-loaders/
        //      https://cssloaders.github.io/
        //      https://loading.io/css/
        return html`<style>:host{overflow:hidden;display:flex;flex-direction:column}svg{width:16px;height:16px}h3{line-height:1.5555555556;font-size:18px;font-weight:300;color:#005380;margin:0;padding:8px 0;padding-right:8px}.header{display:flex;align-items:center}.circle{border:2px solid;border-radius:100%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;color:#005380;cursor:pointer;margin:0 4px}.circle svg{margin:0}.counter{color:#fff;background:#005380;cursor:default;border-color:#005380;width:auto;min-width:24px;font-size:initial}.zeta{line-height:1.75;font-size:12px;font-weight:400}.gray100{color:#6b6a61}.delta{line-height:1.3125;font-size:16px;font-weight:400}.taskItem{display:flex;flex-direction:row;align-items:center;padding:4px 12px;cursor:pointer}.taskItem .taskicon{color:#005380;padding-right:12px}.taskItem:hover{background-color:#e9f0f4}.loader,.loader:after{border-radius:50%;width:16px;height:16px}.loader{border:3px solid rgba(0,83,128,.3);border-left:3px solid #005380;transform:translateZ(0);animation:spinner 1.1s infinite linear;display:inline-block}@keyframes spinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style>`;
    }

    /**
     * Get the tasks API url
     * @param {string} tokenIssuerUrl the token issuer
     * @returns {string} the task API url
     */
     _ba(tokenIssuerUrl) {
        return `https://${(tokenIssuerUrl.indexOf('onpowel') > 0 || origin.indexOf('powel.net') > 0
            ? 'tasks.onpowel.com'
            : tokenIssuerUrl.indexOf('qaidsrv') > 0
                ? 'powelapiqatasks.azurewebsites.net'
                : 'powelapicitasks.azurewebsites.net')}`
              //: 'tasks.local.voluead.volue.com')
    }

    /**
     * Get the PF API url
     * @param {string} tokenIssuerUrl the token issuer
     * @returns {string} the PF API url
     */
     _bc(tokenIssuerUrl) {
        return `https://${(tokenIssuerUrl.indexOf('onpowel') > 0 || origin.indexOf('powel.net') > 0
            ? 'pfacilitiesapi.onpowel.com'
            : tokenIssuerUrl.indexOf('qaidsrv') > 0
                ? 'powelappqaprivatefacilitiesapi.azurewebsites.net'
                : 'powelappciprivatefacilitiesapi.azurewebsites.net')}`
    }
}

// Define the new web component
if (!window.customElements.get(tag)) {
    window.customElements.define(tag, WaveMemoTasksElement);
}